import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import { useSelector } from "react-redux";
import {
  Autocomplete,
  Pagination,
  TextField,
  IconButton,
  Button,
  Typography,
  FormControl,
  MenuItem,
  Box,
  Checkbox,
  Grid,
  Menu,
  InputLabel,
  List,
  ListItem,
  Snackbar,
  Paper,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SearchIcon from "@mui/icons-material/Search";
import CircularProgress from "@mui/material/CircularProgress";
import { v4 as uuidv4 } from "uuid";
import { Close, RotateRight } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import { baseUrl } from "../../config/api-config";
import { Link, useNavigate } from "react-router-dom";
import { getSubsidiary } from "../../api/accounts";
import SearchDataDialog from "../../components/SearchData";

// import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  // stands for .MuiAutocomplete-option
  option: {
    fontSize: "12px",
  },
}));

let Data=[]
// const GlobalSearch = () => {
//   const subsidiaryRef = useRef();
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [options, setOptions] = useState([]);
//   const [value, setValue] = useState(null);
//   const [open, setOpen] = useState(false);
//    const [id, setId] = useState("");
//   const [offset, setOffset] = useState(0);
//   const [inputValue, setInputValue] = useState("");
//   const { data: user } = useSelector((state) => state.user);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const limit = 100; 
//   const navigate = useNavigate();
//   const [totalData, setTotalData] = useState("");
//   const [subsidiaryChecked, setSubsidiaryChecked] = useState(false);
//   const [subsidiarySearchInputValue, setSubsidiarySearchInputValue] =
//     useState("");
//   const [onInputSearch, setInputSearch] = useState({});
//   const [pagesLoading,setPagesLoading]=useState(false)
//   const [subsdiaryRowData, setSubsidiaryRowData] = useState([]);
//   let timer;
//   const [onSelect,setOnSelected]=useState(false)
//   const onSubsidiaryInputSearch = (event) => {
//     setSubsidiarySearchInputValue(event.target.value);
//     setOnSelected(true);
//     // setInputSearch({ ...onInputSearch, subsidiary_name: event.target.value });
//   };

//   const fetchOptions = async () => {

//     try {
//       const response = await fetch(
//         `${baseUrl}/getGlobalSearch?limit=${limit}&offset=${offset}&search_text=${inputValue}`,
//         {
//           headers: {
//             authorization: user.token,
//           },
//         }
//       );
//       const data = await response.json();
//       if (data?.data) {
//         setTotalData(data?.total);
//         Data=offset === 0?[...data.data]: [...prevOptions, ...data.data];
//       } else {
//         console.error("No data found");
//       }
//       setLoading(false);
//     } catch (error) {
//       setLoading(false);
//       console.error(error);
//     }
//   };
  
//   useEffect(() => {
//     let isMounted = true;
//     if (inputValue.length >= 3 || subsidiarySearchInputValue) {
//       setLoading(true);
//       fetchOptions()
//     };
//   }, [inputValue, subsidiarySearchInputValue]);
  
//   // Function to handle user input change
//   const handleInputChangeType = useCallback((newInputValue) => {
//     setInputValue(newInputValue);
//   }, []);
//   // useEffect(() => {
//   //   // Fetch options after a delay when the input value stabilizes
//   //   const delay = 1000; // Adjust the delay as needed
//   //   const timerId = setTimeout(() => {
//   //     fetchOptions();
//   //   }, delay);

//   //   return () => {
//   //     // Cleanup: Clear the timer when the component unmounts or input changes
//   //     clearTimeout(timerId);
//   //   };
//   // }, [inputValue]);
//   const handleSelect = (event, option) => {
//     window.location.href = `/transaction-type/${option.linkingname}/${option.id}`;
//     setValue(option);
//     setOffset(0);
//     Data=[];
//     // setOpen(false);
//     setInputValue("");
//   };

//   const handlePageChange = async () => {
//     setOffset((prev) => {
//       return prev + 10;
//     });
//   };
//   const handleInputChange = async () => {
//     setValue(null); // Clear the selected value
//     setInputValue("");
//   };
//   useEffect(() => {
//     if (inputValue === "") {
//       Data=[];
//     }
//   }, [inputValue]);
//   const renderInput = (params) => (
//     <div>
//       <TextField
//         size="small"
//         id="search-input"
//         {...params}
//         label="Search"
//         variant="outlined"
//         onChange={(event) => {
//           handleInputChangeType(event.target.value);
//           // setOffset(0);
//           // Data=[];
//           // setInputValue(event.target.value);
//         }}
//         value={inputValue}
//         className="editTextBox"
//         InputProps={{
//           style: { fontSize: 12 },
//           ...params.InputProps,
//           endAdornment: (
//             <>
//               {loading ? <CircularProgress color="inherit" size={20} /> : null}
//               {params.InputProps.endAdornment}
//               <Button
//                 title="Load More"
//                 className="quote-load-more-button"
//                 // disabled={inputValue !== "" ? true : false}
//                 onClick={() => handlePageChange()}
//                 style={{
//                   maxWidth: "30px",
//                   maxHeight: "42px",
//                   minWidth: "30px",
//                   minHeight: "30px",
//                 }}
//               >
//                 {/* //  Load More */}
//                 <RotateRight />
//               </Button>
//               <Button
//                 title="Clear"
//                 className="quote-load-more-button"
//                 // disabled={inputValue !== "" ? true : false}
//                 onClick={() => handleInputChange()}
//                 style={{
//                   maxWidth: "30px",
//                   maxHeight: "42px",
//                   minWidth: "30px",
//                   minHeight: "30px",
//                 }}
//               >
//                 {/* //  Load More */}
//                 <Close />
//               </Button>
//             </>
//           ),
//         }}
//         // autoFocus
//       />
//     </div>
//   );
 
  
//   const handleClose = () => {
//     setOpen(false);
//     setSubsidiaryChecked(false);
//   };
//   const classes = useStyles();
//   // const handleClear = () => {
//   //   // Clear the value when the clear button is clicked
//   //   setValue(null); // Clear the selected value
//   //   setInputValue("");
//   // };
//   const open1 = Boolean(anchorEl);
//   const handleClick1 = (event) => {
//     setAnchorEl(event.currentTarget);
//   };
//   const handleClose1 = (event) => {
//     if (event.target.name === "subsidiary_name") {
//       setSubsidiaryChecked(event.target.checked);
//       setSubsidiarySearchInputValue("");
//       setAnchorEl();
//       setOptions("");
//       setOnSelected(false);
//       setInputSearch({ ...onInputSearch, subsidiary_name: "" });
//     }
//   };


//   async function getSubsidiaryData() {
//     try {
//       const { data } = await getSubsidiary(user.token, {});
//       setSubsidiaryRowData(data?.data);
//     } catch (error) {
//       console.log(error);
//       Snackbar.showError("Error In Loading Data.");
//     } finally {
//       // setLoading(false)
//     }
//   }
//   const handleClickReset = (event) => {
//     setInputSearch({});

//     setSubsidiaryChecked(false);
//   };
//   return (
//     <div>
//       <Grid container dispay={"flex"} alignItems="center">
      
//           <Grid item md={9} sm={9} xs={9}>
//             <Autocomplete
//               // open={open}
//               clearIcon={false}
//               classes={{ option: classes.option }}
//               fullWidth
              
//               options={Data}
//               getOptionLabel={(option) =>
//                 option.documentnumber + " " + option.transactiontype
//               }
//               //getOptionLabel={getOptionLabel}
//               onInputChange={(event, newInputValue) => {
//                 handleInputChangeType(newInputValue);
//                 // setInputValue(newInputValue);
//                 // // handle arrow button click here
//                 // if (newInputValue.endsWith("")) {
//                 //   console.log("lenghth", options.length);
//                 //   // handle arrow button click here
//                 //   setOpen(true); // open the options list
//                 // }
//               }}
//               renderInput={renderInput}
//               value={value}
//               onChange={handleSelect}
//               size="small"
//               sx={{ mt: 1.5 }}
//             />
//           </Grid>
       
//       </Grid>
//       <SearchDataDialog open={open} id={id} handleClose={handleClose} fetchOptions={fetchOptions} />
//     </div>
    
//   );
 
// };

// export default GlobalSearch;

// const GlobalSearch = () => {
//   const subsidiaryRef = useRef();
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [options, setOptions] = useState([]);
//   const [value, setValue] = useState(null);
//   const [open, setOpen] = useState(false);
//   const [id, setId] = useState("");
//   const [offset, setOffset] = useState(0);
//   const [inputValue, setInputValue] = useState("");
//   const { data: user } = useSelector((state) => state.user);
//   const [loading, setLoading] = useState(false);
//   const [totalData, setTotalData] = useState("");
//   const limit = 100; 
//   const navigate = useNavigate();
//   const [subsidiaryChecked, setSubsidiaryChecked] = useState(false);
//   const [subsidiarySearchInputValue, setSubsidiarySearchInputValue] = useState("");
//   const [subsidiaryRowData, setSubsidiaryRowData] = useState([]);
  
//   const fetchOptions = async () => {
//     setLoading(true); // Start loading
//     try {
//       const response = await fetch(
//         `${baseUrl}/getGlobalSearch?limit=${limit}&offset=${offset}&search_text=${inputValue}`,
//         {
//           headers: {
//             authorization: user.token,
//           },
//         }
//       );
//       const data = await response.json();
//       if (data?.data) {
//         setTotalData(data?.total);
//         setOptions((prevOptions) => {
//           // If offset is 0, reset the options
//           if (offset === 0) {
//             return [...data.data]; // Reset to new data
//           } else {
//             return [...prevOptions, ...data.data]; // Append to existing data
//           }
//         });
//       } else {
//         console.error("No data found");
//       }
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setLoading(false); // Stop loading
//     }
//   };

//   useEffect(() => {
//     if (inputValue.length >= 3 || subsidiarySearchInputValue) {
//       fetchOptions();
//     }
//   }, [inputValue, subsidiarySearchInputValue, offset]);

//   // Handle user input change
//   const handleInputChangeType = useCallback((newInputValue) => {
//     setInputValue(newInputValue);
//     setOffset(0); // Reset offset when input changes
//   }, []);

//   // Handle select option
//   const handleSelect = (event, option) => {
//     window.location.href = `/transaction-type/${option.linkingname}/${option.id}`;
//     setValue(option);
//     setOffset(0);
//     setInputValue(""); // Reset input value
//     setOptions([]); // Reset options on selection
//   };

//   // Handle page change for pagination
//   const handlePageChange = async () => {
//     setOffset((prev) => prev + 10); // Increment offset for pagination
//   };

//   // Render input component for autocomplete
//   const renderInput = (params) => (
//     <div>
//       <TextField
//         size="small"
//         id="search-input"
//         {...params}
//         label="Search"
//         variant="outlined"
//         onChange={(event) => {
//           handleInputChangeType(event.target.value);
//         }}
//         value={inputValue}
//         className="editTextBox"
//         InputProps={{
//           style: { fontSize: 12 },
//           ...params.InputProps,
//           endAdornment: (
//             <>
//               {loading ? <CircularProgress color="inherit" size={20} /> : null}
//               {params.InputProps.endAdornment}
//               <Button
//                 title="Load More"
//                 onClick={() => handlePageChange()}
//                 style={{
//                   maxWidth: "30px",
//                   maxHeight: "42px",
//                   minWidth: "30px",
//                   minHeight: "30px",
//                 }}
//               >
//                 <RotateRight />
//               </Button>
//               <Button
//                 title="Clear"
//                 onClick={() => {
//                   setInputValue("");
//                   setOptions([]);
//                 }}
//                 style={{
//                   maxWidth: "30px",
//                   maxHeight: "42px",
//                   minWidth: "30px",
//                   minHeight: "30px",
//                 }}
//               >
//                 <Close />
//               </Button>
//             </>
//           ),
//         }}
//       />
//     </div>
//   );

//   return (
//     <div>
//       <Grid container dispay={"flex"} alignItems="center">
//         <Grid item md={9} sm={9} xs={9}>
//           <Autocomplete
//             clearIcon={false}
//             classes={{ option: useStyles().option }}
//             fullWidth
//             options={options} // Use options state here
//             getOptionLabel={(option) =>
//               option.documentnumber + " " + option.transactiontype
//             }
//             onInputChange={(event, newInputValue) => {
//               handleInputChangeType(newInputValue);
//             }}
//             renderInput={renderInput}
//             value={value}
//             onChange={handleSelect}
//             size="small"
//             sx={{ mt: 1.5 }}
//           />
//         </Grid>
//       </Grid>
//       {/* <SearchDataDialog open={open} id={id} handleClose={handleClose} fetchOptions={fetchOptions} /> */}
//     </div>
//   );
// };

// export default GlobalSearch;

// const GlobalSearch = () => {
//   const subsidiaryRef = useRef();
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [options, setOptions] = useState([]); // State for storing options
//   const [value, setValue] = useState(null);
//   const [open, setOpen] = useState(false); // Track whether the dropdown is open
//   const [id, setId] = useState("");
//   const [offset, setOffset] = useState(0);
//   const [inputValue, setInputValue] = useState("");
//   const { data: user } = useSelector((state) => state.user);
//   const [loading, setLoading] = useState(false);
//   const [totalData, setTotalData] = useState("");
//   const limit = 100; 
//   const navigate = useNavigate();
//   const [subsidiaryChecked, setSubsidiaryChecked] = useState(false);
//   const [subsidiarySearchInputValue, setSubsidiarySearchInputValue] = useState("");
//   const [subsidiaryRowData, setSubsidiaryRowData] = useState([]);
  
//   const fetchOptions = async () => {
//     setLoading(true); // Start loading
//     try {
//       const response = await fetch(
//         `${baseUrl}/getGlobalSearch?limit=${limit}&offset=${offset}&search_text=${inputValue}`,
//         {
//           headers: {
//             authorization: user.token,
//           },
//         }
//       );
//       const data = await response.json();
//       console.log(data,"Data")
//       if (data?.data.length > 0) {
//         setTotalData(data?.total);
  
//           // If offset is 0, reset the options
//           if (offset === 0) {
//             setOptions( [...data.data]); // Reset to new data
//           } else {
//             setOptions( [...prevOptions, ...data.data]); // Append to existing data
//           }
  
//         setOpen(true); // Ensure the dropdown is open after fetching options
//       } else {
//         setOptions([]);
//         console.error("No data found");
//       }
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setLoading(false); // Stop loading
//     }
//   };

//   useEffect(() => {
//     if (inputValue.length >= 3 || subsidiarySearchInputValue) {
//       fetchOptions();
//     }
//   }, [inputValue, subsidiarySearchInputValue, offset]);

//   // Handle user input change
//   const handleInputChangeType =(newInputValue) => {
//     setInputValue(newInputValue);
//     // setOffset(0); // Reset offset when input changes
//   };
//   // useEffect(()=>{
//   //  if(inputValue.length === 0){
//   //   setOptions([])
//   //  }
//   // },[inputValue])

//   // Handle select option
//   const handleSelect = (event, option) => {
//     window.location.href = `/transaction-type/${option.linkingname}/${option.id}`;
//     setValue(option);
//     setOffset(0);
//     // setInputValue(""); // Reset input value
//     // setOptions([]); // Reset options on selection
//   };

//   // Handle page change for pagination
//   const handlePageChange = async () => {
//     setOffset((prev) => prev + 10); // Increment offset for pagination
//   };
// console.log(options,"optio")
//   // Render input component for autocomplete
//   const renderInput = (params) => (
//     <div>
//       <TextField
//         size="small"
//         id="search-input"
//         {...params}
//         label="Search"
//         variant="outlined"
//         onChange={(event) => {
//           handleInputChangeType(event.target.value);
//         }}
//         value={inputValue}
//         className="editTextBox"
//         InputProps={{
//           style: { fontSize: 12 },
//           ...params.InputProps,
//           endAdornment: (
//             <>
//               {loading ? <CircularProgress color="inherit" size={20} /> : null}
//               {params.InputProps.endAdornment}
//               <Button
//                 title="Load More"
//                 onClick={() => handlePageChange()}
//                 style={{
//                   maxWidth: "30px",
//                   maxHeight: "42px",
//                   minWidth: "30px",
//                   minHeight: "30px",
//                 }}
//               >
//                 <RotateRight />
//               </Button>
//               <Button
//                 title="Clear"
//                 onClick={() => {
//                   setInputValue("");
//                   setOptions([]);
//                 }}
//                 style={{
//                   maxWidth: "30px",
//                   maxHeight: "42px",
//                   minWidth: "30px",
//                   minHeight: "30px",
//                 }}
//               >
//                 <Close />
//               </Button>
//             </>
//           ),
//         }}
//       />
//     </div>
//   );

//   return (
//     <div>
//       <Grid container display={"flex"} alignItems="center">
//         <Grid item md={9} sm={9} xs={9}>
//           <Autocomplete
//             clearIcon={false}
//             classes={{ option: useStyles().option }}
//             fullWidth
//             options={options} // Use options state here
//             getOptionLabel={(option) =>
//               option.documentnumber + " " + option.transactiontype
//             }
//             onInputChange={(event, newInputValue) => {
//               handleInputChangeType(newInputValue);
//             }}
//             renderInput={renderInput}
//             // value={value}
//             onChange={handleSelect}
//             size="small"
//              // Open the dropdown when options are updated
//             // onOpen={() => setOpen(true)} // Handle opening dropdown when it's clicked
//             // onClose={() => setOpen(false)} // Close the dropdown when user clicks outside
//             sx={{ mt: 1.5 }}
//           />
//         </Grid>
//       </Grid>
      // {/* <SearchDataDialog open={open} id={id} handleClose={handleClose} fetchOptions={fetchOptions} /> */}
//     </div>
//   );
// };

// export default GlobalSearch;


// // Custom Hook to debounce the input value
const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

const GlobalSearch = () => {
  const subsidiaryRef = useRef();
  const [anchorEl, setAnchorEl] = useState(null);
  const [options, setOptions] = useState([]); // State for storing options
  const [value, setValue] = useState(null);
  const [open, setOpen] = useState(false); // Track whether the dropdown is open
  const [id, setId] = useState("");
  const [offset, setOffset] = useState(0);
  const [inputValue, setInputValue] = useState("");
  const { data: user } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [totalData, setTotalData] = useState("");
  const limit = 500;
  const navigate = useNavigate();
  const [subsidiaryChecked, setSubsidiaryChecked] = useState(false);
  const [subsidiarySearchInputValue, setSubsidiarySearchInputValue] = useState("");
  const [subsidiaryRowData, setSubsidiaryRowData] = useState([]);
  
  const debouncedInputValue = useDebounce(inputValue, 800); 

  const fetchOptions = async () => {
    setLoading(true); // Start loading
    try {
      const response = await fetch(
        `${baseUrl}/getGlobalSearch?limit=${limit}&offset=${offset}&search_text=${debouncedInputValue}`,
        {
          headers: {
            authorization: user.token,
          },
        }
      );
      const data = await response.json();
      console.log(data, "Data");
      if (data?.data.length > 0) {
        setTotalData(data?.total);

     
        if (offset === 0) {
          setOptions([...data.data]);
        } else {
          setOptions((prevOptions) => [...prevOptions, ...data.data]); 
        }

        setOpen(true); 
      } else {
        setOptions([]);
        console.error("No data found");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    // Trigger search if input value length is greater than or equal to 3, or if it's a short string
    if ((debouncedInputValue.length >= 3 || debouncedInputValue.length === 0) && user.token) {
      fetchOptions();
    }
  }, [debouncedInputValue, offset,user.token]);

  // Handle user input change
  const handleInputChangeType = (newInputValue) => {
    setInputValue(newInputValue);
    setOffset(0); // Reset offset when input changes
  };

  // Handle select option
  const handleSelect = (event, option) => {
    window.location.href = `/transaction-type/${(option.linkingname==="bill-payment"?"bill-payment-list":option.linkingname==="bill-credit"?"bill-credit-list":option.linkingname==="bill"?"vendor-bill-list":option.linkingname)}/${option.id}`;
    setValue(option);
    setOffset(0);
  };

  // Handle page change for pagination
  const handlePageChange = async () => {
    setOffset((prev) => prev + 10); // Increment offset for pagination
  };

  // Reset options when input is cleared
  useEffect(() => {
    if (inputValue === "") {
      setOptions([]); // Optionally, reset options when the input is cleared
      setTotalData("");
    }
  }, [inputValue]);
  const CustomPaper = (props) => {
    console.log(props,"props")
    return (
      <Paper {...props}>
      <Box sx={{ maxHeight: 340}}>{props.children}</Box>
      {/* Fixed Footer */}
      <Box
        sx={{
          cursor: "pointer",
          p: 1,
          textAlign: "center",
          borderTop: "1px solid #ddd",
          background: "#f9f9f9",
        }}
        onMouseDown={(event) => event.preventDefault()} // ✅ Prevent closing
        onClick={() => navigate(`/global-search-page?search=${debouncedInputValue}`, "")}
      >
        <Typography variant="body2" color="#000">
          Show more results..!
        </Typography>
      </Box>
    </Paper>
    );
  };
  const getLabel = (option) => {
    const { pc_project, documentnumber,document_number, transactiontype, vendor, subsidiary, customer, employee } = option;
    let docNum = documentnumber || "";
  
    if (pc_project?.toLowerCase()?.includes(inputValue?.toLowerCase())) {
      return `Pc project : ${docNum} ${transactiontype} ${pc_project}`;
    }
    if (vendor?.toLowerCase()?.includes(inputValue?.toLowerCase())) {
      return `Vendor : ${docNum} ${transactiontype} ${vendor}`;
    }
    if (subsidiary?.toLowerCase()?.includes(inputValue?.toLowerCase())) {
      return `Subsidiary : ${docNum} ${transactiontype} ${subsidiary}`;
    }
    if (customer?.toLowerCase()?.includes(inputValue?.toLowerCase())) {
      return `Customer : ${docNum} ${transactiontype} ${customer}`;
    }
    if (employee?.toLowerCase()?.includes(inputValue?.toLowerCase())) {
      return `Employee : ${docNum} ${transactiontype} ${employee}`;
    }
    if (document_number?.toLowerCase()?.includes(inputValue?.toLowerCase())) {
      return `Document Number : ${docNum} ${transactiontype} ${document_number}`;
    }
    return `${documentnumber} ${transactiontype}`;
  };
  // Render input component for autocomplete
  const renderInput = (params) => (
    <div>
      <TextField
        size="small"
        id="search-input"
        {...params}
        label="Search"
        variant="outlined"
        onChange={(event) => {
          handleInputChangeType(event.target.value);
        }}
        value={inputValue}
        // focused={inputValue}
        className="editTextBox"
        InputProps={{
          style: { fontSize: 12 },
          ...params.InputProps,
          endAdornment: (
            <>
              {loading ? <CircularProgress color="inherit" size={20} /> : null}
              {params.InputProps.endAdornment}
              <Button
                title="Load More"
                onClick={() => handlePageChange()}
                style={{
                  maxWidth: "30px",
                  maxHeight: "42px",
                  minWidth: "30px",
                  minHeight: "30px",
                }}
              >
                <RotateRight />
              </Button>
              <Button
                title="Clear"
                onClick={() => {
                  setInputValue("");
                  setOptions([]);
                }}
                style={{
                  maxWidth: "30px",
                  maxHeight: "42px",
                  minWidth: "30px",
                  minHeight: "30px",
                }}
              >
                <Close />
              </Button>
            </>
          ),
        }}
      />
    </div>
  );

  return (
    <div>
      <Grid container display={"flex"} alignItems="center">
        <Grid item md={9} sm={9} xs={9}>
          {/* <Autocomplete
            clearIcon={false}
            classes={{ option: useStyles().option }}
            fullWidth
            inputValue={inputValue}
            onOpen={inputValue.length > 0}
            openText={inputValue}
            open={inputValue}
            value={value}
            options={options} // Use options state here
            getOptionLabel={(option) =>
            {
              // if(option?.documentnumber?.toLowerCase()?.includes(inputValue?.toLowerCase())){
              //   return option?.documentnumber + " " + option?.transactiontype
              // }
              if( option?.pc_project?.toLowerCase()?.includes(inputValue?.toLowerCase())){
                return   "Pc project : "+option?.documentnumber + " - "+ option?.transactiontype +" "+ option?.pc_project
              }
              if( option?.vendor?.toLowerCase()?.includes(inputValue?.toLowerCase())){
                return    "Vendor : " +option?.documentnumber + " - "+option?.transactiontype +" "+ option?.vendor
              }
              if( option?.subsidiary?.toLowerCase()?.includes(inputValue?.toLowerCase())){
                return  "Subsidiary : " +option?.documentnumber + " - "+option?.transactiontype +" "+ option?.subsidiary
              }
              if( option?.customer?.toLowerCase()?.includes(inputValue?.toLowerCase())){
                return    "Customer : " +option?.documentnumber + " - "+option?.transactiontype +" "+ option?.customer
              }
              if( option?.employee?.toLowerCase()?.includes(inputValue?.toLowerCase())){
                return  "Employee : " +option?.documentnumber + " - "+ option?.transactiontype +" "+ option?.employee
              }
              return option?.documentnumber + " " + option?.transactiontype
            }
            }
            onInputChange={(event, newInputValue) => {
              handleInputChangeType(newInputValue);
            }}
            renderInput={renderInput}
            onChange={handleSelect}
            size="small"
            sx={{ mt: 1.5 }}
          /> */}
          <Autocomplete
  clearOnBlur={false} 
  fullWidth

  options={options}
  getOptionLabel={getLabel}
  onInputChange={(event, newInputValue) => {
    handleInputChangeType(newInputValue);
  }}
  renderInput={renderInput}
  onChange={handleSelect}
  size="small"
  PaperComponent={CustomPaper} 
  renderOption={(props, option) => (
    <li {...props} key={option.id || `${option.documentnumber}-${option.transactiontype}-${Math.random()}`}>
      {getLabel(option)} 
    </li>
  )}
  sx={{ mt: 1.5 }}
  onBlur={(event) => {
    event.preventDefault();
    setOpen(!open);
  }}
/>
        </Grid>
      </Grid>
    </div>
  );
};

export default GlobalSearch;
// const useDebounce = (value, delay) => {
//   const [debouncedValue, setDebouncedValue] = useState(value);

//   useEffect(() => {
//     const handler = setTimeout(() => {
//       setDebouncedValue(value);
//     }, delay);

//     return () => {
//       clearTimeout(handler);
//     };
//   }, [value, delay]);

//   return debouncedValue;
// };
// const GlobalSearch = () => {
//   const subsidiaryRef = useRef();
//   const searchRef = useRef(null);
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [options, setOptions] = useState([]);
//   const [value, setValue] = useState(null);
//   const [open, setOpen] = useState(false);
//   const [id, setId] = useState("");
//   const [offset, setOffset] = useState(0);
//   const [inputValue, setInputValue] = useState("");
//   const { data: user } = useSelector((state) => state.user);
//   const [loading, setLoading] = useState(false);
//   const [totalData, setTotalData] = useState("");
//   const limit = 500;
//   const navigate = useNavigate();
//   const [subsidiaryChecked, setSubsidiaryChecked] = useState(false);
//   const [subsidiarySearchInputValue, setSubsidiarySearchInputValue] = useState("");
//   const [subsidiaryRowData, setSubsidiaryRowData] = useState([]);
//   const [highlightedIndex, setHighlightedIndex] = useState(-1);
//     const [searchValue, setSearchValue] = useState("");
//   const [searchResults, setSearchResults] = useState([]);
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const debouncedInputValue = useDebounce(inputValue, 500);
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (searchRef.current && !searchRef.current.contains(event.target)) {
//         setDropdownOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);
//   const fetchOptions = async () => {
//     setLoading(true); 
//     try {
//       const response = await fetch(
//         `${baseUrl}/getGlobalSearch?limit=${limit}&offset=${offset}&search_text=${debouncedInputValue}`,
//         {
//           headers: {
//             authorization: user.token,
//           },
//         }
//       );
//       const data = await response.json();
//       if (data?.data.length > 0) {
//         setTotalData(data?.total);

//         if (offset === 0) {
//           setOptions([...data.data]);
//         } else {
//           setOptions((prevOptions) => [...prevOptions, ...data.data]);
//         }

//         setOpen(true);
//       } else {
//         setOptions([]);
//       }
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if ((debouncedInputValue.length >= 3 || debouncedInputValue.length === 0) && user.token) {
//       fetchOptions();
//     }
//   }, [debouncedInputValue, offset, user.token]);

//   useEffect(() => {
//     if (inputValue === "") {
//       setOptions([]);
//       setTotalData("");
//     }
//   }, [inputValue]);

//   // Handle input change
//   const handleInputChangeType = (newInputValue) => {
//     setInputValue(newInputValue);
//     setOffset(0);
//   };

//   // Handle select option
//   const handleSelect = (selectedOption) => {
//     window.location.href = `/transaction-type/${selectedOption.linkingname}/${selectedOption.id}`;
//     setValue(selectedOption);
//     setOffset(0);
//   };

//   // Handle page change for pagination
//   const handlePageChange = async () => {
//     setOffset((prev) => prev + 10);
//   };
//   const handleKeyDown = (e) => {
//     if (e.key === "ArrowDown") {
//       setHighlightedIndex((prev) => Math.min(prev + 1, searchResults.length - 1));
//     } else if (e.key === "ArrowUp") {
//       setHighlightedIndex((prev) => Math.max(prev - 1, 0));
//     } else if (e.key === "Enter" && highlightedIndex !== -1) {
//       handleSelect(searchResults[highlightedIndex]);
//     } else if (e.key === "Escape") {
//       setDropdownOpen(false);
//     }
//   };

//   // Custom option rendering logic
//   const getOptionLabel = (option) => {
//     if(option?.documentnumber?.toLowerCase()?.includes(inputValue?.toLowerCase())) {
//       return option?.documentnumber + " " + option?.transactiontype;
//     }
//     if( option?.pc_project?.toLowerCase()?.includes(inputValue?.toLowerCase())) {
//       return "Pc project : "+option?.documentnumber + " - "+ option?.transactiontype +" "+ option?.pc_project;
//     }
//     if( option?.vendor?.toLowerCase()?.includes(inputValue?.toLowerCase())) {
//       return "Vendor : " + option?.documentnumber + " - "+ option?.transactiontype +" "+ option?.vendor;
//     }
//     if( option?.subsidiary?.toLowerCase()?.includes(inputValue?.toLowerCase())) {
//       return "Subsidiary : " + option?.documentnumber + " - "+ option?.transactiontype +" "+ option?.subsidiary;
//     }
//     if( option?.customer?.toLowerCase()?.includes(inputValue?.toLowerCase())) {
//       return "Customer : " + option?.documentnumber + " - "+ option?.transactiontype +" "+ option?.customer;
//     }
//     if( option?.employee?.toLowerCase()?.includes(inputValue?.toLowerCase())) {
//       return "Employee : " + option?.documentnumber + " - "+ option?.transactiontype +" "+ option?.employee;
//     }
//     return option?.documentnumber + " " + option?.transactiontype;
//   };


//     // Handle input change
//   const handleInputChange = (e) => {
//     setSearchValue(e.target.value);
//     setHighlightedIndex(-1);
//   };

//   // Render input component for react-select
//   const customSingleValue = (props) => {
//     return (
//       <TextField
//         {...props}
//         label="Search"
//         variant="outlined"
//         size="small"
//         onChange={(event) => handleInputChangeType(event.target.value)}
//         value={inputValue}
//         InputProps={{
//           style: { fontSize: 12 },
//         }}
//       />
//     );
//   };

//   return (
//     <div>
//       <Grid container display={"flex"} alignItems="center">
//         <Grid item md={9} sm={9} xs={9}>

//         <div className="relative w-72 mx-auto" ref={searchRef}>
//       {/* Search Input */}
//       <div className="relative">
//         <input
//           className="w-full p-2 border border-gray-300 rounded text-gray-700 pr-10 outline-none focus:ring-2 focus:ring-blue-400"
//           type="text"
//           value={inputValue}
//           onChange={(event) => handleInputChangeType(event.target.value)}
//           onKeyDown={handleKeyDown}
//           placeholder="Search something..."
//         />
//         {/* Clear Icon */}
//         {inputValue && (
//           <div
//             className="absolute right-3 top-2 text-gray-400 cursor-pointer"
//             onClick={() => {
//               setSearchValue("");
//               setSearchResults([]);
//               setDropdownOpen(false);
//             }}
//           >
//             ❌
//           </div>
//         )}
//       </div>

//       {/* Dropdown Menu */}
//       {inputValue && (
//         <div
//           style={{ boxShadow: "3px 15px 24px -3px #000" }}
//           className="absolute top-full mt-2 w-full bg-white border border-gray-200 rounded-md z-10 max-h-60 overflow-y-auto"
//         >
//           <ul className="divide-y divide-gray-200">
//             {loading ? <p className="p-2 text-center text-gray-500">Loading...</p> : options?.length > 0 ? (
//               options?.map((item, index) => (
//                 <li
//                   key={index}
//                   className={`p-2 cursor-pointer ${
//                     highlightedIndex === index ? "bg-gray-700 text-white" : "hover:bg-gray-100"
//                   }`}
//                   onClick={() => handleSelect(item)}
//                   onMouseEnter={() => setHighlightedIndex(index)}
//                 >
//                   ✅ {item.documentnumber} - {item.transactiontype}
//                 </li>
//               ))
//             ) : (
//               <p className="p-2 text-center text-gray-500">✘ No results found..😟</p>
//             )}
//           </ul>
//         </div>
//       )}
//     </div>
//           {/* <Select
//             isClearable={true}
//             defaultValue={ {value:inputValue,label:inputValue}}
//             // isSearchable
//             options={options}
//             getOptionLabel={getOptionLabel}
//             onInputChange={handleInputChangeType}
//             onChange={handleSelect}
//             value={inputValue ? {value:inputValue,label:inputValue}   :value}
//             // menuIsOpen={open}
//             isLoading={loading}
//             // onFocus={() => setOpen(true)} // Ensure the dropdown opens when input is focused
//             // onBlur={() => setOpen(false)} // Close the dropdown on blur
//             // components={{ SingleValue: customSingleValue }}
//             inputValue={inputValue}
//             placeholder="Search"
//             styles={{
//               control: (provided) => ({
//                 ...provided,
//                 fontSize: "12px",
//               }),
//             }}
//             formatOptionLabel={getOptionLabel}
//             noOptionsMessage={() => (loading ? <CircularProgress color="inherit" size={20} /> : "No options found")}
//           /> */}
//         </Grid>
//       </Grid>
//     </div>
//   );
// };

// export default GlobalSearch;



// const useDebounce = (value, delay) => {
//   const [debouncedValue, setDebouncedValue] = useState(value);

//   useEffect(() => {
//     const handler = setTimeout(() => {
//       setDebouncedValue(value);
//     }, delay);

//     return () => {
//       clearTimeout(handler);
//     };
//   }, [value, delay]);

//   return debouncedValue;
// };

// const GlobalSearch = () => {
//   const [searchValue, setSearchValue] = useState("");
//   const [searchResults, setSearchResults] = useState([]);
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [highlightedIndex, setHighlightedIndex] = useState(-1);
//   const searchRef = useRef(null);
//   const debouncedSearch = useDebounce(searchValue, 500);
//   const limit = 500;
//   const { data: user } = useSelector((state) => state.user);
//   // Fetch search results from API
//   const fetchSearchResults = async () => {
//     if (!debouncedSearch) {
//       setSearchResults([]);
//       setDropdownOpen(false);
//       return;
//     }

//     try {
//              const response = await fetch(
//                 `${baseUrl}/getGlobalSearch?limit=${limit}&offset=${offset}&search_text=${debouncedInputValue}`,
//                 {
//                   headers: {
//                     authorization: user.token,
//                   },
//                 }
//               );
//       const data = await response.json();

//       if (data?.data?.length > 0) {
//         setSearchResults(data.data);
//         setDropdownOpen(true);
//       } else {
//         setSearchResults([]);
//         setDropdownOpen(false);
//       }
//     } catch (error) {
//       console.error("Error fetching search results:", error);
//       setDropdownOpen(false);
//     }
//   };

//   useEffect(() => {
//     fetchSearchResults();
//   }, [debouncedSearch]);

//   // Handle input change
//   const handleInputChange = (e) => {
//     setSearchValue(e.target.value);
//     setHighlightedIndex(-1);
//   };

//   // Handle option select
//   const handleSelect = (selectedItem) => {
//     window.location.href = `/transaction-type/${selectedItem.linkingname}/${selectedItem.id}`;
//     setSearchValue("");
//     setSearchResults([]);
//     setDropdownOpen(false);
//   };

//   // Handle keyboard navigation
//   const handleKeyDown = (e) => {
//     if (e.key === "ArrowDown") {
//       setHighlightedIndex((prev) => Math.min(prev + 1, searchResults.length - 1));
//     } else if (e.key === "ArrowUp") {
//       setHighlightedIndex((prev) => Math.max(prev - 1, 0));
//     } else if (e.key === "Enter" && highlightedIndex !== -1) {
//       handleSelect(searchResults[highlightedIndex]);
//     } else if (e.key === "Escape") {
//       setDropdownOpen(false);
//     }
//   };

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (searchRef.current && !searchRef.current.contains(event.target)) {
//         setDropdownOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   return (
//     <div className="relative w-72 mx-auto" ref={searchRef}>
//       {/* Search Input */}
//       <div className="relative">
//         <input
//           className="w-full p-2 border border-gray-300 rounded text-gray-700 pr-10 outline-none focus:ring-2 focus:ring-blue-400"
//           type="text"
//           value={searchValue}
//           onChange={handleInputChange}
//           onKeyDown={handleKeyDown}
//           placeholder="Search something..."
//         />
//         {/* Clear Icon */}
//         {searchValue && (
//           <div
//             className="absolute right-3 top-2 text-gray-400 cursor-pointer"
//             onClick={() => {
//               setSearchValue("");
//               setSearchResults([]);
//               setDropdownOpen(false);
//             }}
//           >
//             ❌
//           </div>
//         )}
//       </div>

//       {/* Dropdown Menu */}
//       {dropdownOpen && (
//         <div
//           style={{ boxShadow: "3px 15px 24px -3px #000" }}
//           className="absolute top-full mt-2 w-full bg-white border border-gray-200 rounded-md z-10 max-h-60 overflow-y-auto"
//         >
//           <ul className="divide-y divide-gray-200">
//             {searchResults.length > 0 ? (
//               searchResults.map((item, index) => (
//                 <li
//                   key={index}
//                   className={`p-2 cursor-pointer ${
//                     highlightedIndex === index ? "bg-gray-700 text-white" : "hover:bg-gray-100"
//                   }`}
//                   onClick={() => handleSelect(item)}
//                   onMouseEnter={() => setHighlightedIndex(index)}
//                 >
//                   ✅ {item.documentnumber} - {item.transactiontype}
//                 </li>
//               ))
//             ) : (
//               <p className="p-2 text-center text-gray-500">✘ No results found..😟</p>
//             )}
//           </ul>
//         </div>
//       )}
//     </div>
//   );
// };

// export default GlobalSearch;
